import(/* webpackMode: "eager" */ "/vercel/path0/src/app/discover/new/page.tsx");
